import {
    IDuvidaTecnicaRequest,
    IResponderDuvidaTecnicaRequest,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/DuvidaTecnica/DuvidaTecnicaInterface";
import {
    IListarMotivoNaoProcedencia,
    ISolicitacaoNaoProcedenteAvaliar,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/SolicitacaoNaoProcedente/SolicitacaoNaoProcedente";
import {
    IListarMotivoParalisarManutencao,
    IParalisarManutencao,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/ParalisarManutencao/ParalisarManutencaoInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";
import {
    TiposVistoria,
    IVistoriaExecutada,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/VistoriaProcedente/VistoriaProcedenteInterface";
import { IListarMotivoParalisarNaoProcedencia } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/MotivoNaoProcedencia/MotivoNaoProcedencia";

export function AvancarEtapaTipoCasoDeAtendimentoService(idCaso: number) {
    return Service(
        Axios.get(`/home/atendimentos/avancaretapa?idCaso=${idCaso}`)
    );
}

export function VerificaExisteAgendamentoService(idCaso?: number) {
    return Service(
        Axios.get(`/home/agendamento/existeagendamento?idCaso=${idCaso}`)
    );
}
export function DuvidaTecnicaService(
    idCaso: number,
    requestBody: IDuvidaTecnicaRequest
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/acaoatendimento/duvidatecnica?idCaso=${idCaso}`,
            requestBody
        )
    );
}

export function ResponderDuvidaTecnicaService(
    idCaso: number,
    requestBody: IResponderDuvidaTecnicaRequest
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/acaoatendimento/responderduvidatecnica?idCaso=${idCaso}`,
            requestBody
        )
    );
}

export function TecnicoNaoCompareceuService(
    idCaso: number,
    etapaTipoCaso: number,
    ClienteVisualizaHistorico: boolean
) {
    return Service(
        Axios.get(
            `/assistenciatecnica/acaoatendimento/tecniconaocompareceu?idCaso=${idCaso}&etapaTipoCaso=${etapaTipoCaso}&flClienteVisualizaHistorico=${ClienteVisualizaHistorico}`
        )
    );
}

export function VistoriaNaoRealizadaService(
    idCaso: number,
    flEmpresa: "Cliente" | "Empresa"
) {
    return Service(
        Axios.get(
            `/assistenciatecnica/acaoatendimento/execucaonaorealizada?idCaso=${idCaso}&enumBotaoNaoRealizado=${flEmpresa}`
        )
    );
}

export function ListarMotivoParalisarService() {
    return Service(
        Axios.get<Array<IListarMotivoParalisarManutencao>>(
            `/assistenciatecnica/paralizacao/listarmotivoparalizacao`
        )
    );
}

export function ObterMotivoParalisarService(idMotivoParalizacao: number) {
    return Service(
        Axios.get(
            `/assistenciatecnica/paralizacao/obtermotivoparalizacao?idMotivoParalizacao=${idMotivoParalizacao}`
        )
    );
}

export function DeletarMotivoParalisarService(idMotivoParalizacao: number) {
    return Service(
        Axios.delete(
            `/assistenciatecnica/paralizacao/removermotivoparalizacao?idMotivoParalizacao=${idMotivoParalizacao}`
        )
    );
}

export function InserirMotivoParalisarService(
    requestBody: IListarMotivoParalisarManutencao
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/paralizacao/inserirmotivoparalizacao`,
            requestBody
        )
    );
}

export function EditarMotivoParalisarService(
    requestBody: IListarMotivoParalisarManutencao
) {
    return Service(
        Axios.put(
            `/assistenciatecnica/paralizacao/editarmotivoparalizacao`,
            requestBody
        )
    );
}

export function ParalisarAtendimentoService(requestBody: IParalisarManutencao) {
    return Service(
        Axios.put(
            `/assistenciatecnica/paralizacao/paralizaratendimento`,
            requestBody
        )
    );
}

export function ReiniciarAtendimentoService(idCaso: number) {
    return Service(
        Axios.put(
            `/assistenciatecnica/paralizacao/reiniciaratendimento?idCaso=${idCaso}`
        )
    );
}

export function ListarMotivoNaoProcedenciaService(idCaso: number) {
    return Service(
        Axios.get<Array<IListarMotivoNaoProcedencia>>(
            `/assistenciatecnica/atendimentos/listarmotivonaoprocedencia?idTipoCaso=${idCaso}`
        )
    );
}

export function SolicitacaoNaoProcedenteService(
    tipoSolicitacao: "ConstrutoraAvaliara" | "FinalizarSolicitacao",
    requestBody: ISolicitacaoNaoProcedenteAvaliar
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/acaoatendimento/solicitacaonaoprocedente?solicitacaonaoProcedente=${tipoSolicitacao}`,
            requestBody
        )
    );
}

export function FechamentoSolicitacaoService(
    requestBody?: ISolicitacaoNaoProcedenteAvaliar
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/acaoatendimento/fechamentosolicitacao`,
            requestBody
        )
    );
}

export function ManutencaoNaoConcluidaService(idCaso: number) {
    return Service(
        Axios.get(
            `/assistenciatecnica/acaoatendimento/manutencaonaoconcluida?idCaso=${idCaso}&flClienteVisualizaHistorico=true`
        )
    );
}

export function ValidarSolicitacaoNaoProcedenteService(idCaso: number) {
    return Service(
        Axios.get(
            `/assistenciatecnica/acaoatendimento/validacaosolicitacaonaoprocedente?idCaso=${idCaso}`
        )
    );
}

export function VistoriaExecutadaSolicitacaoProcedenteService(
    idCaso: number,
    tipoVistoria: TiposVistoria,
    requestBody: IVistoriaExecutada
) {
    return Service(
        Axios.put(
            `/assistenciatecnica/acaoatendimento/vistoriaprocedente?idCaso=${idCaso}&tipoVistoria=${tipoVistoria}`,
            requestBody
        )
    );
}

export function AvancarSemResponderPesquisaServices(idCaso: number) {
    return Service(
        Axios.get(
            `/assistenciatecnica/acaoatendimento/pularpesquisasatisfacao?idCaso=${idCaso}`
        )
    );
}

export function ReenviarEmailPesquisaSatisfacaoServices(idCaso: number, ID_TIPO_CASO: number) {
    return Service(
        Axios.get(
            `/assistenciatecnica/acaoatendimento/reenviaemailpesquisasatisfacao?idCaso=${idCaso}&ID_TIPO_CASO=${ID_TIPO_CASO}`
        )
    );
}

export function ResultadoVistoriaService(ID_CASO: number, RESULTADO: string) {
    return Service(
        Axios.get(
            `/assistenciatecnica/atendimentos/resultadovistoria?ID_CASO=${ID_CASO}&RESULTADO=${RESULTADO}`
        )
    );
}

export function ListagemDosMotivoNaoProcedenciaService() {
    return Service(
        Axios.get<Array<IListarMotivoParalisarNaoProcedencia>>(
            `/home/motivonaoprocedencia/listarmotivonaoprocedencia`
        )
    );
}

export function ObterMotivoNaoProcedenciaService(
    idMotivoNaoProcedencia: number
) {
    return Service(
        Axios.get<IListarMotivoParalisarNaoProcedencia>(
            `/home/motivonaoprocedencia/obtermotivonaoprocedencia?idMotivoNaoProcedencia=${idMotivoNaoProcedencia}`
        )
    );
}

export function CadastrarMotivoNaoProcedenciaService(
    requestBody: IListarMotivoParalisarNaoProcedencia
) {
    return Service(
        Axios.post(
            `/home/motivonaoprocedencia/cadastrarmotivonaoprocedencia`,
            requestBody
        )
    );
}

export function EditarMotivoNaoProcedenciaService(
    requestBody: IListarMotivoParalisarNaoProcedencia
) {
    return Service(
        Axios.put(
            `/home/motivonaoprocedencia/editarmotivonaoprocedencia`,
            requestBody
        )
    );
}

export function DeletarMotivoNaoProcedenciaService(
    idMotivoNaoProcedencia: number
) {
    return Service(
        Axios.delete(
            `/home/motivonaoprocedencia/removermotivonaoprocedencia?idMotivoNaoProcedencia=${idMotivoNaoProcedencia}`
        )
    );
}
